module.exports = __webpack_public_path__ + "static/media/history.9cb34df5.svg";